import { Sector } from '../company/sector';
import { SocialLink } from '../company/social-link';
import { CompanyDetails } from '../company/company-details';

export class BusinessDirectoryInfo {
  address: string;
  companyBannerAttachmentId: number;
  companyBannerUrl: string;
  companyDetail: CompanyDetails;
  companyLogoAttachmentId: number;
  companyLogoUrl: string;
  id: number;
  isCreator: boolean;
  name: string;
  brandName: string;
  registrationNumber: string;
  sectors: Sector[];
  slug: string;
  socialLinks: SocialLink[];
  tagline: string;
  websiteUrl: string;
  videoUrl: string;
  isSubscribed: boolean;
}
